// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3JAwp","hiddenGymBadge":"styles_hiddenGymBadge__2djVM","box":"styles_box__3coiJ","backBtn":"styles_backBtn__3hqeG"};